const EmailDomainList = ["@microsoft.com", "@github.com", "@nuance.com"];
const ERROR_TYPES = {
  REQUIRED: "Subscribing at least one user or group is required for this entity.",
  INVALID: `Please provide a valid user, group, or e-mail. Supported e-mail domains: ${EmailDomainList.join(",")}.`,
  SEARCH_FAILED: "The search operation failed. Please retry or open a DRI ticket if this happens again."
};
const TIPS = {
  LABEL_TEXT: "Subscribers",
  LOADING_TEXT: "Loading",
  ICON_CALLOUT_TEXT: "The subscribed users and email addresses will receive email notifications.",
  INPUT_PLACEHOLDER: "Search for a name/group/email",
  SUGGESTION_LOADING_TEXT: "Searching",
  SUGGESTION_NO_RESULT_TEXT: "No results found",
  SUGGESTION_AVAILABLE_ALERT_TEXT: "People picker suggestions available",
  CHECKBOX_LABEL: "Subscribe me",
  DROPDOWN_ALL_TEXT: "All domains"
};
const ADMIN_SUBSCRIBER_SUFFIX = " (Admin)";
export {
  ADMIN_SUBSCRIBER_SUFFIX,
  ERROR_TYPES,
  EmailDomainList,
  TIPS
};
//# sourceMappingURL=Subscriber.constants.js.map
